import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MenuController, ModalController } from "@ionic/angular";
import { SyncService } from "@app/@services/api/sync/sync.service";
import { BehaviorSubject } from "rxjs";

import { OfferService } from "@services/offer/offer.service";

@Component({
  selector: "app-common-header",
  templateUrl: "./common-header.component.html",
  styleUrls: ["./common-header.component.scss"],
})
export class CommonHeaderComponent {
  @Output()
  filterIconTap = new EventEmitter();

  @Output()
  leftIconTap = new EventEmitter();

  @Output()
  rightIconTap = new EventEmitter();

  @Input()
  title: string = "";

  @Input()
  hasFilter = false;

  @Input()
  hasLogo = false;

  @Input()
  hasDrawer = false;

  @Input()
  hasTutorial = false;

  @Input()
  hasQuestionTutorial = false;

  @Input() disableDrawerButton = false;

  @Input()
  isLight = false;

  // this variable is deprecated
  @Input()
  isDark = false;


  syncStatus: BehaviorSubject<boolean>;
  shouldShowOfferButton: BehaviorSubject<boolean>;


  constructor(
    private menuCtrl: MenuController,
    private modalController: ModalController,
    private syncService: SyncService,
    private offerService: OfferService
  ) {
    this.syncStatus = this.syncService.getSyncStatus();
    this.shouldShowOfferButton = this.offerService.getShowPromo();
  }

  _filterIconTap() {
    this.filterIconTap.emit();
  }

  _leftIconTap() {
    this.leftIconTap.emit();
  }

  _rightIconTap() {
    this.rightIconTap.emit();
  }

  menuToggle() {
    this.menuCtrl.toggle();
  }

  close() {
    this.modalController.dismiss();
  }

  onBackButton() {
    alert("show back button");
  }

  


}
